import React from 'react';
import { ChartConstants } from './util';

export interface IChartBackgroundProps {
    chartRect: ClientRect;
}

export class ChartBackground extends React.Component<IChartBackgroundProps> {
    public render(): React.ReactElement {
        const { chartRect } = this.props;
        return (
            <clipPath id="chart-background">
                <rect
                    x={0}
                    y={0}
                    // NB: add extract space for dots that are on the x-axis (zero y-value)
                    height={chartRect.height + ChartConstants.dotRadius + ChartConstants.dotStrokeWidth}
                    width={chartRect.width}
                />
            </clipPath>
        );
    }
}
